import { Navigate } from "react-router-dom";

import { isPatientActive } from "~/common/utils";
import { ScreeningQuestion } from "~/patients/components";
import { useGetCurrentPatient } from "~/patients/hooks";
import { ROUTES } from "~/patients/router";

export const Screening = () => {
  const { data: user } = useGetCurrentPatient();

  if (isPatientActive(user?.organization_patients[0].status))
    return <Navigate to={ROUTES.notFound} />;

  return <ScreeningQuestion />;
};
